import type { Meta, StoryObj } from "@storybook/react";

import { fakeOtherInfoSectionProps } from "@/__mocks__/profile/overview";
import type { OtherInfoSectionProps } from "@/ui/components/profile";
import { OtherInfoSection } from "@/ui/components/profile";
import { Box } from "@/ui/layout";
import type {
  Permission,
  UserPermissionsType,
} from "@/utils/profile/permissions.util";
import {
  getPermissionChecker,
  UserPermissionsTypes,
} from "@/utils/profile/permissions.util";

const AllPermissions = "all";

const StoryMeta: Meta<
  { permissionsProfile: "all" | UserPermissionsType } & OtherInfoSectionProps
> = {
  title: "Components/Profile/Other Info",
  component: OtherInfoSection,
  argTypes: {
    dateOfBirth: { control: "text" },
    languages: { control: "object" },
    permissionsProfile: {
      control: "select",
      options: [...Object.keys(UserPermissionsTypes), AllPermissions],
    },
    relationToPatient: { control: "text" },
  },
  args: {
    ...fakeOtherInfoSectionProps(),
    permissionsProfile: AllPermissions,
  },
  render: (props) => {
    const { permissionsProfile } = props;
    const userPermissions =
      permissionsProfile === AllPermissions
        ? (): Permission => "editAndView"
        : getPermissionChecker(UserPermissionsTypes[permissionsProfile]);

    return (
      <Box width="100%">
        <OtherInfoSection {...props} userPermissions={userPermissions} />
      </Box>
    );
  },
};

type Story = StoryObj<OtherInfoSectionProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
